import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Components
import * as S from './Styled';
import { useHistory, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { getEnv } from '../../../utils';
import { Helmet } from 'react-helmet';
import TagManager from 'gtm-for-react';

const ENV_MODE = getEnv();
const IS_PRODUCTION = ENV_MODE === 'production';

const propTypes = {
  children: PropTypes.object.isRequired,
};

const Generic = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const GA_ID = document.documentElement.style.getPropertyValue('--ga');
  const GTM_ID = document.documentElement.style.getPropertyValue('--gtm');

  // initializing google analytics
  useEffect(() => {
    if (!GA_ID || !IS_PRODUCTION) {
      return;
    }

    ReactGA.initialize(GA_ID);
  }, [GA_ID]);

  // initializing google tag manager
  useEffect(() => {
    if (!GTM_ID || !IS_PRODUCTION) {
      return;
    }

    const tagManagerArgs = {
      gtmId: GTM_ID,
    };

    TagManager.initialize(tagManagerArgs);
  }, [GTM_ID]);

  useEffect(() => {
    if (IS_PRODUCTION)
      history.listen(location => {
        ReactGA.send({
          hitType: 'pageview',
          page: location.pathname,
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <S.Layout>
      <S.Wrapper>{children}</S.Wrapper>

      {IS_PRODUCTION && (
        <Helmet
          script={[
            {
              type: 'text/javascript',
              innerHTML: (function (h, o, t, j, a, r) {
                h.hj =
                  h.hj ||
                  function () {
                    (h.hj.q = h.hj.q || []).push(arguments);
                  };
                h._hjSettings = { hjid: 1875432, hjsv: 6 };
                a = o.getElementsByTagName('head')[0];
                r = o.createElement('script');
                r.async = 1;
                r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                a.appendChild(r);
              })(
                window,
                document,
                'https://static.hotjar.com/c/hotjar-',
                '.js?sv='
              ),
            },
          ]}
        />
      )}
    </S.Layout>
  );
};

Generic.propTypes = propTypes;

export default Generic;
